export const CART_ACTION_TYPES = {
  SET_CART_ITEMS: "cart/SET_CART_ITEMS",
  SET_ISCART_OPEN: "cart/SET_ISCART_OPEN",
};
